import {Injectable} from '@angular/core';
import {
  IPlatformCommandHandler,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {PlatformCommand} from '@shared/commands/command-base';
import {MatDialog} from '@angular/material/dialog';
import {take, takeUntil} from 'rxjs/operators';
import {DialogService} from "@shared/services/dialog-service";
import {DialogModel} from "@shared/models/dialog.model";
import { SpreadsheetState } from '../store/spreadsheet.reducer';
import { select, Store } from '@ngrx/store';
import { getCurrentProject, ProjectState } from '@features/projects/store/reducers/projects.reducer';
import { ProjectModel } from '@features/projects/models/projects.models';
import { FlexSheetService } from './flex-sheet.service';

@Injectable({
  providedIn: 'root',
})

export class ManageStageAreaCommandHandler implements IPlatformCommandHandler {
  currentWorkbookId: string;
  constructor(
    protected dialogService: DialogService,
    private store: Store<SpreadsheetState>,
    private projectStore: Store<ProjectState>,
    private flexSheetService: FlexSheetService
  ) {
  }

  executeCommand(command: PlatformCommand, handler: IPlatformToolHandler, callback?: any): boolean {

    this.projectStore.pipe(select(getCurrentProject), take(1)).subscribe( (project: ProjectModel) => {
      if (project) {
        command.projectId = project.ProjectId;
      }
    });

    const dialogModel = DialogModel.create('Manage Staging Area(s)', 'ManageStageAreaDialogComponent', {}, '600px', '600px');
    const currentWorksheet = this.flexSheetService.getCurrentWorkSheet();
    const currentWorkbook = this.flexSheetService.getCurrentWorkBook();
    const workbookId = currentWorkbook.id;
    const worksheetId = currentWorksheet.id;
    dialogModel.input = {workbookId: workbookId, worksheetId: worksheetId};
    this.dialogService.showOkCancelDialog(dialogModel)
      .subscribe(actionState => {
        if (actionState && actionState.action === 'OK') {
          const sourceTypeGroup = actionState.data.input.sourceTypeGroup;
          sourceTypeGroup.sourceTypes.forEach(sourceType => {
            if(sourceType.fieldDefinitions) {
              sourceType.fieldDefinitions = sourceType.fieldDefinitions.filter(field => field.isSelected);
            }
          });
          command.name =  'AddEventSourceModelCommand'
          command.fieldValues['CommandName'] = 'ManageStageAreaCommand';
          command.fieldValues['EventSourceId'] = command.fieldValues['WorkbookSetId'];
          command.fieldValues['SourceType'] = 'WorkbookSet';

          command.fieldValues['SourceMappingStage'] = actionState.data.input.sourceTypeGroup;
          command.fieldValues['ReferenceType'] = actionState.data.input.referenceType;
          handler.executeCommand(command);
        }
      });
     return true;
    }
}
